import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export function initPartnersCarousel() {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.js-partners-carousel').forEach((el) => {
            new Swiper(el, {
                modules: [Autoplay],
                slidesPerView: 2.5,
                spaceBetween: 40,
                loop: true,
                loopAdditionalSlides: 10,
                speed: 3000,
                grabCursor: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    1400: {
                        slidesPerView: 5,
                    },
                },
            });
        });
    });
}
